'use client'

import React from 'react'

export interface TestimonialCardProps {
  quoteText: string
  quoteDescription: string
  author: string
  starCount?: number
  /** page.module.css 등 testimonial 관련 클래스가 있는 CSS module */
  styles: Record<string, string>
}

const DEFAULT_STAR_COUNT = 4

export function TestimonialCard({
  quoteText,
  quoteDescription,
  author,
  starCount = DEFAULT_STAR_COUNT,
  styles,
}: TestimonialCardProps) {
  return (
    <div className={styles.testimonialCard}>
      <div className={styles.testimonialContent}>
        <div className={styles.testimonialQuote}>
          <svg className={styles.quoteIcon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path  d="M6 6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a3 3 0 0 1-3 3H5a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2H6Zm9 0a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3Z" />
            </svg>
          <div
            className={styles.quoteText}
            dangerouslySetInnerHTML={{ __html: quoteText }}
          />
        </div>
        <div className={styles.quoteDescription}>{quoteDescription}</div>
      </div>
      <div className={styles.testimonialFooter}>
        <div className={styles.starGroup}>
          {Array.from({ length: starCount }, (_, i) => (
            <div key={i} className={styles.star}> 
              <svg className={styles.starInner} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z"/>
              </svg> 
            </div>
          ))}
        </div>
        <div className={styles.testimonialAuthor}>{author}</div>
      </div>
    </div>
  )
}
